import Divider from "@material-ui/core/Divider";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";

import AsyncInfiniteScrollList from "../AsyncInfiniteScrollList";
import IncidentReportListItem from "../IncidentReportListItem";
import watchQueryApprovedIncidentReports from "../../api/functions/watchQueryApprovedIncidentReports";

const fetchSize = 20;

const IncidentReportList = ({ propertyId }) => {
  const [data, setData] = useState({
    loading: true,
    error: null,
    incidentReports: [],
    nextToken: null,
  });
  const observableQuery = useMemo(
    () =>
      watchQueryApprovedIncidentReports({
        propertyId,
        first: fetchSize,
      }),
    [propertyId]
  );
  useEffect(() => {
    const subscription = observableQuery.subscribe(
      ({ data, loading }) => {
        const { items, nextToken } = data.queryApprovedIncidentReports;
        setData((prevState) => ({
          ...prevState,
          loading,
          incidentReports: items,
          nextToken,
        }));
      },
      (error) =>
        setData((prevState) => ({ ...prevState, loading: false, error }))
    );
    return () => {
      subscription.unsubscribe();
    };
  }, [observableQuery]);
  const handleLoadMore = async () => {
    observableQuery.fetchMore({
      variables: {
        propertyId,
        first: fetchSize,
        after: data.nextToken,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const {
          queryApprovedIncidentReports: { items, nextToken },
        } = fetchMoreResult;
        return {
          ...previousResult,
          queryApprovedIncidentReports: {
            ...previousResult.queryApprovedIncidentReports,
            items: [
              ...previousResult.queryApprovedIncidentReports.items,
              ...items,
            ],
            nextToken,
          },
        };
      },
    });
  };
  const handleRefetch = async () => {
    setData((prevState) => ({ ...prevState, loading: true, error: null }));
    try {
      await observableQuery.refetch();
    } catch (error) {
      setData((prevState) => ({ ...prevState, loading: false, error }));
    }
  };
  return (
    <AsyncInfiniteScrollList
      error={data.error}
      hasMore={Boolean(data.nextToken)}
      loading={data.loading}
      loadMore={handleLoadMore}
      onRefetch={handleRefetch}
    >
      {data.incidentReports.map((incidentReport, index) => (
        <div key={incidentReport.incidentId}>
          {index !== 0 && <Divider />}
          <IncidentReportListItem incidentReport={incidentReport} />
        </div>
      ))}
    </AsyncInfiniteScrollList>
  );
};

IncidentReportList.propTypes = {
  propertyId: PropTypes.string.isRequired,
};

export default IncidentReportList;
